module.exports = __webpack_public_path__ + "static/media/password.fad9cdd1.svg";